import React from 'react';
import './chapters.scss';
import FloatingCubes from '../FloatingCubes/FloatingCubes';

function Vision() {
  return (
    <section className="chapters chapters-vision">
      <FloatingCubes origin="vision" />
      <h3>
        Intel’s Vision for AI and <span className="linebreak">the Road Ahead</span>
      </h3>

      <p>
        Much of the technology being developed by Nachman and her team is being made available to
        developers around the world as open-source tools. “I have always been optimistic about the
        ability of technology to improve equity in the world,” Nachman says. “And the reason for
        that is that I feel like it can scale in ways that physical resources can't. When I think
        about the common thread for all these stories, I think we all see the power of AI, to be a
        transformative power for good.”
      </p>
    </section>
  );
}

export default Vision;
